// Block types: { p }, { h }, { ul: [] }, { lines: [] }, { table: { head: [], rows: [[]] } }

const ADDRESS = ["LUMIRON SAS", "76 Boulevard Maurice Barrès", "92200 Neuilly-sur-Seine", "France"];

export const privacy = {
  fr: {
    eyebrow: "Juridique",
    title: "Politique de confidentialité",
    sections: [
      {
        title: "Responsable du traitement",
        blocks: [
          {
            p: "La présente Politique de confidentialité explique comment LUMIRON SAS collecte, utilise, conserve et protège les données personnelles lorsque vous accédez à nos sites web, produits et services basés sur l'intelligence artificielle, y compris iko.",
          },
          {
            lines: [
              "LUMIRON SAS",
              "Société par actions simplifiée (SAS)",
              "Immatriculée au Registre du Commerce et des Sociétés de Nanterre sous le n° 988 278 446",
            ],
          },
          {
            lines: ["Siège social :", "76 Boulevard Maurice Barrès", "92200 Neuilly-sur-Seine", "France"],
          },
          { p: "Email : contact@lumiron.ai" },
        ],
      },
      {
        title: "Champ d'application",
        blocks: [
          { p: "La présente Politique de confidentialité s'applique :" },
          {
            ul: [
              "aux visiteurs de nos sites web ;",
              "aux clients utilisant nos Services ;",
              "aux prospects ;",
              "aux utilisateurs interagissant avec nos solutions d'IA ;",
              "aux personnes dont les informations sont traitées via des intégrations autorisées par nos clients.",
            ],
          },
          {
            p: "Selon le contexte, Lumiron agit soit en tant que Responsable du traitement, soit en tant que Sous-traitant au sens du Règlement général sur la protection des données (RGPD).",
          },
          {
            p: "Lumiron agit en tant que Responsable du traitement pour les données relatives à l'utilisation du site web, aux comptes clients, à la facturation, aux demandes d'assistance et aux communications commerciales.",
          },
          {
            p: "Lorsque les clients utilisent nos Services avec leurs propres données professionnelles, Lumiron agit en tant que Sous-traitant et traite les données exclusivement pour le compte du client, conformément aux contrats applicables et aux instructions du client.",
          },
        ],
      },
      {
        title: "Informations collectées",
        blocks: [
          {
            p: "Selon l'utilisation qui est faite de nos Services, nous pouvons collecter les catégories d'informations suivantes.",
          },
          { h: "Informations de compte" },
          {
            ul: [
              "Nom",
              "Adresse email professionnelle",
              "Informations sur l'entreprise",
              "Informations du compte utilisateur",
              "Informations d'authentification",
            ],
          },
          { h: "Informations de facturation" },
          {
            ul: [
              "Adresse de facturation",
              "Informations relatives au paiement",
              "Factures",
              "Détails de l'abonnement",
            ],
          },
          { h: "Informations techniques" },
          {
            ul: [
              "Adresse IP",
              "Informations sur l'appareil",
              "Type de navigateur",
              "Système d'exploitation",
              "Fichiers journaux",
              "Informations de session",
              "Informations de diagnostic",
            ],
          },
          { h: "Données de service" },
          { p: "Lorsque les clients utilisent nos Services, nous pouvons traiter :" },
          {
            ul: [
              "les requêtes et conversations ;",
              "les réponses générées par l'IA ;",
              "les fichiers et documents importés ;",
              "les interactions vocales le cas échéant ;",
              "les données de workflows ;",
              "les informations synchronisées via des intégrations autorisées par le client, telles que les calendriers, services de messagerie, CRM, plateformes de stockage cloud, outils collaboratifs et autres applications professionnelles connectées.",
            ],
          },
          { p: "Nous traitons ces informations uniquement pour fournir les Services demandés." },
        ],
      },
      {
        title: "Finalités du traitement",
        blocks: [
          { p: "Nous traitons les données personnelles pour les finalités suivantes :" },
          { h: "Exécution de nos Services" },
          {
            ul: [
              "fournir l'accès à notre plateforme ;",
              "authentifier les utilisateurs ;",
              "fournir les fonctionnalités basées sur l'IA ;",
              "exécuter les workflows ;",
              "traiter les demandes ;",
              "assurer le support client ;",
              "gérer les abonnements ;",
              "assurer la facturation.",
            ],
          },
          { h: "Intérêts légitimes" },
          {
            ul: [
              "améliorer la fiabilité de nos Services ;",
              "surveiller les performances du système ;",
              "prévenir la fraude et les abus ;",
              "garantir la sécurité de la plateforme ;",
              "détecter les problèmes techniques ;",
              "maintenir la qualité de service.",
            ],
          },
          { h: "Obligations légales" },
          {
            ul: [
              "obligations comptables ;",
              "conformité fiscale ;",
              "demandes légales des autorités compétentes ;",
              "conformité réglementaire.",
            ],
          },
          { h: "Consentement" },
          { p: "Lorsque la loi l'exige, nous nous fondons sur le consentement pour :" },
          {
            ul: [
              "les communications marketing ;",
              "les cookies optionnels ;",
              "les technologies d'analyse nécessitant un consentement préalable.",
            ],
          },
        ],
      },
      {
        title: "Traitement par intelligence artificielle",
        blocks: [
          {
            p: "Nos Services utilisent l'intelligence artificielle pour automatiser des workflows, générer des réponses et assister les utilisateurs.",
          },
          {
            p: "Pour fournir ces fonctionnalités, certaines requêtes peuvent être traitées de manière sécurisée par des fournisseurs de services d'IA soigneusement sélectionnés, agissant pour le compte de Lumiron.",
          },
          {
            p: "Lumiron sélectionne des fournisseurs offrant des engagements contractuels en matière de confidentialité, de sécurité et de protection des données.",
          },
          { p: "Les données clients sont traitées uniquement dans le but de fournir les Services demandés." },
          {
            p: "Lumiron ne vend pas les données clients et n'utilise pas les informations clients à des fins publicitaires.",
          },
        ],
      },
      {
        title: "Amélioration des services",
        blocks: [
          { p: "Nous améliorons en continu la fiabilité, la qualité et la sécurité de nos Services." },
          {
            p: "Dans la mesure du possible, ces améliorations s'appuient sur des journaux techniques, des informations anonymisées ou des statistiques agrégées.",
          },
          {
            p: "Tout traitement réalisé à des fins d'amélioration des services est effectué conformément à la réglementation applicable en matière de protection des données.",
          },
        ],
      },
      {
        title: "Partage des données",
        blocks: [
          { p: "Nous ne vendons jamais de données personnelles." },
          {
            p: "Les données personnelles peuvent uniquement être partagées avec des prestataires de confiance nécessaires au fonctionnement de nos Services, notamment :",
          },
          {
            ul: [
              "fournisseurs d'infrastructure cloud ;",
              "fournisseurs d'authentification ;",
              "prestataires de paiement ;",
              "fournisseurs d'infrastructure d'IA ;",
              "opérateurs de télécommunications ;",
              "prestataires de support client ;",
              "fournisseurs d'outils d'analyse.",
            ],
          },
          {
            p: "Ces prestataires sont contractuellement tenus de mettre en œuvre des mesures de sécurité appropriées et de ne traiter les données personnelles qu'à des fins autorisées.",
          },
          {
            p: "Nous pouvons également divulguer des informations lorsque la loi applicable l'exige ou sur demande légitime des autorités publiques.",
          },
        ],
      },
      {
        title: "Transferts internationaux de données",
        blocks: [
          {
            p: "Certains de nos prestataires peuvent traiter des données personnelles en dehors de l'Espace économique européen (EEE).",
          },
          {
            p: "Lorsque de tels transferts ont lieu, Lumiron veille à ce que des garanties appropriées soient mises en place, notamment :",
          },
          {
            ul: [
              "les décisions d'adéquation de la Commission européenne ;",
              "les Clauses contractuelles types (CCT) ;",
              "ou tout autre mécanisme de transfert reconnu par le RGPD.",
            ],
          },
        ],
      },
      {
        title: "Durée de conservation",
        blocks: [
          {
            p: "Les données personnelles sont conservées uniquement pendant la durée nécessaire aux finalités décrites dans la présente Politique de confidentialité.",
          },
          { p: "Les durées de conservation habituelles sont les suivantes :" },
          {
            table: {
              head: ["Catégorie de données", "Durée de conservation"],
              rows: [
                ["Compte client", "Durée de la relation contractuelle + 12 mois"],
                ["Données de facturation", "10 ans"],
                ["Support client", "Jusqu'à 3 ans"],
                ["Contacts marketing", "3 ans après le dernier contact"],
                ["Journaux techniques", "Conservation limitée selon les besoins opérationnels"],
                ["Cookies", "Jusqu'à 13 mois le cas échéant"],
              ],
            },
          },
        ],
      },
      {
        title: "Sécurité",
        blocks: [
          { p: "La protection des informations de nos clients est une priorité fondamentale chez Lumiron." },
          {
            p: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger les données personnelles, notamment :",
          },
          {
            ul: [
              "des communications chiffrées via les protocoles TLS standards du secteur ;",
              "le chiffrement des données sensibles lorsque cela est approprié ;",
              "une infrastructure cloud sécurisée ;",
              "des contrôles d'accès basés sur les rôles ;",
              "des mécanismes d'authentification et d'autorisation ;",
              "la surveillance de l'infrastructure ;",
              "la journalisation des accès (audit) ;",
              "des sauvegardes régulières ;",
              "des procédures de gestion des vulnérabilités ;",
              "un accès des collaborateurs restreint au strict besoin.",
            ],
          },
          { p: "Seul le personnel autorisé a accès aux systèmes contenant des données personnelles." },
          {
            p: "Bien qu'aucun système ne puisse garantir une sécurité absolue, Lumiron revoit et améliore en continu ses pratiques de sécurité afin de maintenir un haut niveau de protection.",
          },
          {
            p: "Les clients restent responsables de la protection de leurs propres identifiants et de la gestion des accès aux services tiers connectés.",
          },
        ],
      },
      {
        title: "Vos droits",
        blocks: [
          { p: "Sous réserve de la loi applicable, chaque personne peut exercer les droits suivants :" },
          {
            ul: [
              "Droit d'accès",
              "Droit de rectification",
              "Droit à l'effacement",
              "Droit à la limitation du traitement",
              "Droit d'opposition",
              "Droit à la portabilité des données",
            ],
          },
          { p: "Les demandes peuvent être adressées à : contact@lumiron.ai" },
          { p: "Nous répondrons dans les délais prévus par la loi applicable." },
          {
            p: "Chaque personne dispose également du droit d'introduire une réclamation auprès de son autorité de protection des données, notamment la Commission nationale de l'informatique et des libertés (CNIL).",
          },
        ],
      },
      {
        title: "Cookies",
        blocks: [
          { p: "Nos sites web utilisent des cookies et technologies similaires afin de :" },
          {
            ul: [
              "assurer le bon fonctionnement du site ;",
              "améliorer l'expérience utilisateur ;",
              "mesurer les performances du site ;",
              "analyser l'utilisation du site ;",
              "renforcer la sécurité.",
            ],
          },
          {
            p: "Lorsque la loi l'exige, les cookies non essentiels ne sont déposés qu'après avoir obtenu le consentement de l'utilisateur.",
          },
          {
            p: "Les utilisateurs peuvent accepter, refuser ou modifier leurs préférences en matière de cookies à tout moment via le bandeau cookies ou les outils de gestion des préférences disponibles.",
          },
        ],
      },
      {
        title: "Contact",
        blocks: [
          {
            p: "Pour toute question concernant la présente Politique de confidentialité ou le traitement des données personnelles, vous pouvez contacter :",
          },
          { lines: ADDRESS },
          { p: "Email : contact@lumiron.ai" },
        ],
      },
    ],
  },
  en: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    sections: [
      {
        title: "Data Controller",
        blocks: [
          {
            p: "This Privacy Policy explains how LUMIRON SAS collects, uses, stores and protects personal data when you access our websites, products and AI-powered services, including iko.",
          },
          {
            lines: [
              "LUMIRON SAS",
              "Simplified Joint-Stock Company (SAS)",
              "Registered with the Nanterre Trade and Companies Register under No. 988 278 446",
            ],
          },
          {
            lines: ["Registered Office:", "76 Boulevard Maurice Barrès", "92200 Neuilly-sur-Seine", "France"],
          },
          { p: "Email: contact@lumiron.ai" },
        ],
      },
      {
        title: "Scope",
        blocks: [
          { p: "This Privacy Policy applies to:" },
          {
            ul: [
              "visitors of our websites;",
              "customers using our Services;",
              "prospective customers;",
              "users interacting with our AI-powered solutions;",
              "individuals whose information is processed through integrations authorized by our customers.",
            ],
          },
          {
            p: "Depending on the context, Lumiron acts either as a Data Controller or as a Data Processor under the General Data Protection Regulation (GDPR).",
          },
          {
            p: "Lumiron acts as a Data Controller for data relating to website usage, customer accounts, billing, support requests and commercial communications.",
          },
          {
            p: "When customers use our Services with their own business data, Lumiron acts as a Data Processor and processes data solely on behalf of the customer, in accordance with applicable agreements and customer instructions.",
          },
        ],
      },
      {
        title: "Information We Collect",
        blocks: [
          {
            p: "Depending on how our Services are used, we may collect the following categories of information.",
          },
          { h: "Account Information" },
          {
            ul: [
              "Name",
              "Business email address",
              "Company information",
              "User account information",
              "Authentication information",
            ],
          },
          { h: "Billing Information" },
          { ul: ["Billing address", "Payment-related information", "Invoices", "Subscription details"] },
          { h: "Technical Information" },
          {
            ul: [
              "IP address",
              "Device information",
              "Browser type",
              "Operating system",
              "Log files",
              "Session information",
              "Diagnostic information",
            ],
          },
          { h: "Service Data" },
          { p: "When customers use our Services, we may process:" },
          {
            ul: [
              "prompts and conversations;",
              "AI-generated responses;",
              "uploaded files and documents;",
              "voice interactions where applicable;",
              "workflow data;",
              "information synchronized through customer-authorized integrations such as calendars, email services, CRM systems, cloud storage platforms, collaboration tools and other connected business applications.",
            ],
          },
          { p: "We process this information only to deliver the requested Services." },
        ],
      },
      {
        title: "Purposes of Processing",
        blocks: [
          { p: "We process personal data for the following purposes:" },
          { h: "Performance of our Services" },
          {
            ul: [
              "providing access to our platform;",
              "authenticating users;",
              "delivering AI-powered features;",
              "executing workflows;",
              "processing requests;",
              "customer support;",
              "subscription management;",
              "billing.",
            ],
          },
          { h: "Legitimate Interests" },
          {
            ul: [
              "improving the reliability of our Services;",
              "monitoring system performance;",
              "preventing fraud and abuse;",
              "ensuring platform security;",
              "detecting technical issues;",
              "maintaining service quality.",
            ],
          },
          { h: "Legal Obligations" },
          {
            ul: [
              "accounting obligations;",
              "tax compliance;",
              "legal requests from competent authorities;",
              "regulatory compliance.",
            ],
          },
          { h: "Consent" },
          { p: "Where required by applicable law, we rely on consent for:" },
          {
            ul: [
              "marketing communications;",
              "optional cookies;",
              "analytics technologies requiring prior consent.",
            ],
          },
        ],
      },
      {
        title: "Artificial Intelligence Processing",
        blocks: [
          {
            p: "Our Services use artificial intelligence to automate workflows, generate responses and assist users.",
          },
          {
            p: "To provide these features, certain requests may be securely processed through carefully selected AI service providers acting on Lumiron's behalf.",
          },
          {
            p: "Lumiron selects providers that offer contractual commitments regarding confidentiality, security and data protection.",
          },
          { p: "Customer data is processed solely for the purpose of providing the requested Services." },
          {
            p: "Lumiron does not sell customer data and does not use customer information for advertising purposes.",
          },
        ],
      },
      {
        title: "Service Improvement",
        blocks: [
          { p: "We continuously improve the reliability, quality and security of our Services." },
          {
            p: "Where possible, improvements rely on technical logs, anonymized information or aggregated statistics.",
          },
          {
            p: "Any processing performed for service improvement is carried out in accordance with applicable data protection laws.",
          },
        ],
      },
      {
        title: "Data Sharing",
        blocks: [
          { p: "We never sell personal data." },
          {
            p: "Personal data may only be shared with trusted service providers necessary for operating our Services, including:",
          },
          {
            ul: [
              "cloud infrastructure providers;",
              "authentication providers;",
              "payment providers;",
              "AI infrastructure providers;",
              "telecommunications providers;",
              "customer support providers;",
              "analytics providers.",
            ],
          },
          {
            p: "These providers are contractually required to implement appropriate security measures and process personal data only for authorized purposes.",
          },
          {
            p: "We may also disclose information where required by applicable law or by a lawful request from public authorities.",
          },
        ],
      },
      {
        title: "International Data Transfers",
        blocks: [
          {
            p: "Some of our service providers may process personal data outside the European Economic Area (EEA).",
          },
          {
            p: "Whenever international transfers occur, Lumiron ensures that appropriate safeguards are implemented, including:",
          },
          {
            ul: [
              "European Commission Adequacy Decisions;",
              "Standard Contractual Clauses (SCCs);",
              "or other lawful transfer mechanisms recognized under the GDPR.",
            ],
          },
        ],
      },
      {
        title: "Data Retention",
        blocks: [
          {
            p: "Personal data is retained only for as long as necessary to fulfil the purposes described in this Privacy Policy.",
          },
          { p: "Typical retention periods include:" },
          {
            table: {
              head: ["Data Category", "Retention Period"],
              rows: [
                ["Customer Account", "Duration of the contractual relationship + 12 months"],
                ["Billing Records", "10 years"],
                ["Customer Support", "Up to 3 years"],
                ["Marketing Contacts", "3 years after the last interaction"],
                ["Technical Logs", "Limited retention according to operational needs"],
                ["Cookies", "Up to 13 months where applicable"],
              ],
            },
          },
        ],
      },
      {
        title: "Security",
        blocks: [
          { p: "Protecting customer information is a core priority at Lumiron." },
          {
            p: "We implement appropriate technical and organizational measures designed to safeguard personal data, including:",
          },
          {
            ul: [
              "encrypted communications using industry-standard TLS protocols;",
              "encryption of sensitive data where appropriate;",
              "secure cloud infrastructure;",
              "role-based access controls;",
              "authentication and authorization mechanisms;",
              "infrastructure monitoring;",
              "audit logging;",
              "regular backups;",
              "vulnerability management procedures;",
              "restricted employee access based on business need.",
            ],
          },
          { p: "Only authorized personnel have access to systems containing personal data." },
          {
            p: "Although no system can guarantee absolute security, Lumiron continuously reviews and improves its security practices to maintain a high level of protection.",
          },
          {
            p: "Customers remain responsible for protecting their own account credentials and managing access to connected third-party services.",
          },
        ],
      },
      {
        title: "Your Rights",
        blocks: [
          { p: "Subject to applicable law, individuals may exercise the following rights:" },
          {
            ul: [
              "Right of access",
              "Right to rectification",
              "Right to erasure",
              "Right to restriction",
              "Right to object",
              "Right to data portability",
            ],
          },
          { p: "Requests may be submitted at: contact@lumiron.ai" },
          { p: "We will respond within the timeframe required by applicable law." },
          {
            p: "Individuals also have the right to lodge a complaint with their local data protection authority, including the French Data Protection Authority (CNIL).",
          },
        ],
      },
      {
        title: "Cookies",
        blocks: [
          { p: "Our websites use cookies and similar technologies to:" },
          {
            ul: [
              "ensure the proper operation of the website;",
              "improve user experience;",
              "measure website performance;",
              "analyze website usage;",
              "enhance security.",
            ],
          },
          {
            p: "Where required by law, non-essential cookies are only placed after obtaining user consent.",
          },
          {
            p: "Users may accept, refuse or modify their cookie preferences at any time through the cookie banner or available preference management tools.",
          },
        ],
      },
      {
        title: "Contact",
        blocks: [
          {
            p: "If you have any questions regarding this Privacy Policy or the processing of personal data, please contact:",
          },
          { lines: ADDRESS },
          { p: "Email: contact@lumiron.ai" },
        ],
      },
    ],
  },
};
